import { Component } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { CheckPageAccess } from 'src/app/components/authorize/check-page-access';
import { CreateTagDefaultValues, CreateTag } from 'src/app/components/tags/tags';
import { TagsService } from 'src/app/services/tag-service.service';
import { ToastService } from 'src/app/services/toast-service.service';

@Component({
    selector: 'app-create-tag',
    templateUrl: './create-tag.component.html',
    styleUrls: ['./create-tag.component.scss'],
    standalone: false
})

export class CreateTagComponent {
  createTag: CreateTag = CreateTagDefaultValues();
  tagCategories: any[] = [];
  selectedCategory: any[] = [];
  selectedCategoryName: string = '';
  isSubmitted: boolean = false;
  tagStatus: string = "active";
  hideReviewPanel: boolean = true;
  pageName = CheckPageAccess.ADDTAG;

  constructor(public _tagservice: TagsService, public _toast: ToastService, public router: Router) { }

  ngOnInit(): void {
    this._tagservice.getAllCategories().subscribe({
      next: (data) => this.tagCategories = data,
      error: (error) => console.log(error)
    });
  }

  onCategoryCheckboxChange() {
    this.createTag.tagsCategoriesId = this.selectedCategory;
  }

  getCategoryNames(id: number): string {
    const cat = this.tagCategories.find(t => t.id === id);
    return cat ? cat.categoryName : '';
  }

  isItemChecked(item: any, selectedItems: any[]): boolean {
    if (selectedItems === undefined) {
      return false;
    }

    return selectedItems.some((selectedItem) => selectedItem.id === item.id);
  }

  onMACheckboxChange(item: any): void {
    let selectedcategories: any[] = [];

    if (this.isItemChecked(item, this.selectedCategory)) {
      this.selectedCategory = this.selectedCategory.filter((i) => i.id !== item.id);
    }
    else {
      this.selectedCategory.push({
        id: item.id,
        categoryName: item.categoryName
      });
    }

    this.selectedCategoryName = this.selectedCategory
      .map(i => i.categoryName)
      .join(',');
  }

  addTag(_t48: NgForm) {
    this.isSubmitted = true;
    this.createTag.tagsCategoriesId = this.selectedCategory;

    if (this.tagStatus == 'active') {
      this.createTag.isActive = true;
    }
    else {
      this.createTag.isActive = false;
    }

    if (!this.validateTagForm()) {
      return;
    }

    this._tagservice.createTag(this.createTag).subscribe({
        next: (res) => {
          if (res) {
            this._toast.showMessage("Tag Created successfully");
            this.router.navigateByUrl("/tags-list");
          }
          else {
            this._toast.showMessage("This Tag already exists");
          }
        }
      });
  }

  review() {
    this.hideReviewPanel = false;
  }

  goback() {
    this.hideReviewPanel = true;
  }

  validateTagForm(): boolean {
     let flag=true;

     if (this.createTag.tagName == '') {
       flag = false;
     }

     if (this.createTag.tagsCategoriesId.length == 0) {
       flag = false;
     }

     return flag;
  }
}
